import CustomTable from "../../../../../components/table/CustomTable";
import React from "react";
import AttendanceHead from "./AttendanceHead";
import {AttendancePeriodTableApp} from "../Functionality/AttendancePeriodTableApp";
import FullPageLoader from "../../../../../utils/FullPageLoader";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendancePeriodTable = ({
    selectedOption,
    searchElement,
    search,
    option,
    setSimpleSearch,
    setSearch,
    setFinalArray,
    finalArray,
    setSearchElement,
    setBodyForExport,
    searchClean,
    contractorId,
    supplierId,
    setSendSimpleSearch,
    setSelectedOption,
    view,
    setView,
    render,
    setRender,
    color,
    activeStep,
    modified,
    setModified,
    handleView,
    prevIsDaily
}) => {

    const {
        attendanceStartDate,
        attendanceEndDate,
        rowsPerPage,
        tableId,
        thead,
        tbody,
        pagination,
        searchId,
        setResults,
        selectedDate,
        setSelectedDate,
        loadingDays,
    } = AttendancePeriodTableApp({
        selectedOption,
        setSelectedOption,
        searchElement,
        setSearchElement,
        option,
        finalArray,
        setRender,
        color,
        setBodyForExport,
        modified,
        setModified,
        prevIsDaily
    });

    return (
        <>
            {loadingDays && <FullPageLoader id="overlay_attendance_days" portal />}
            <AttendanceHead
                view={view}
                setView={setView}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                attendanceStartDate={attendanceStartDate}
                attendanceEndDate={attendanceEndDate}
                selectedOption={selectedOption}
                setSimpleSearch={setSimpleSearch}
                searchClean={searchClean}
                setSearch={setSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                search={search}
                setSendSimpleSearch={setSendSimpleSearch}
                finalArray={finalArray}
                setSelectedOption={setSelectedOption}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                handleView={handleView}
                prevIsDaily={prevIsDaily}
            />
            <div className={"col-12"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    textNotInformation={'no_information_attendance'}
                    withoutHeight={true}
                />
            </div>
            {pagination()}
            {render}
        </>

    )

}
export default AttendancePeriodTable
